import { GenericObject, toCamelCase } from "@taager/reinforcements";

export function toCamelCaseObjectKeys<T extends GenericObject>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [toCamelCase(key), value]),
  ) as T;
}
